import React, { Component } from 'react'

class NotFound extends React.Component {
  render() {
    return <h1>NotFound Container</h1>
  }
}

export default NotFound
